export default __webpack_public_path__ + "static/media/maj-contour-icon.d401fa92.svg";